<div class="container-fluid p-3">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <div class="flex gap-3">
    
      <div class="flex-1">
        <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
          {{stepDetails?.name}}
        </h4>
    
        <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
          [{{ projectName }}]
        </h5>
    
    
      </div>
      <div>
        
        <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all" [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
          <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
          {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
        </span>
      </div>
    </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">

        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
 <div class="container-fluid">
  <div class="mb-10 mt-8 transition-all duration-200 hover:shadow-md">
    <div class="">
      <div class="">
        <div>
          <div class="divide-y divide-gray-200">
            
            <ng-container *ngFor="let row of winners; let i = index">
              <div>
                <!-- Header -->
                <div
                  class="flex items-center justify-between p-4 my-3 cursor-pointer bg-gray-300/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
                  (click)="row.isSectionOpen = !row.isSectionOpen"
                >
                  <div class="flex items-center">
                    <!-- First letter of vendor name -->
                    <span
                      class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-base font-bold"
                    >
                      {{ row.company_name?.charAt(0) || row.vendor.company_name?.charAt(0) || '-' }}
                    </span>
            
                    <!-- Vendor name -->
                    <span class="font-semibold text-lg">
                      {{ row.company_name || row.vendor.company_name || '-' }}
                    </span>
            
                    <!-- Status chip -->
                    <span
                      *ngIf="row.vendor_status"
                      class="ml-3 px-2 py-1 text-sm font-medium border-2 rounded-lg"
                      [ngClass]="{
                        'border-green-600 text-green-600 bg-green-100': row.vendor_status === 'Qualify',
                        'border-red-600 text-red-600 bg-red-100': row.vendor_status === 'Disqualify'
                      }"
                    >
                      {{
                        row.vendor_status === 'Qualify' ? 'Shortlisted'
                        : row.vendor_status === 'Disqualify' ? 'Not Shortlisted'
                        : row.vendor_status
                      }}
                    </span>
                  </div>
            
                  <!-- Qualify / Disqualify buttons -->
                  <div class="flex gap-2" *ngIf="!row.vendor_status">
                    <button
                      [disabled]="!stepDetails.can_edit"
                      class="px-3 py-1 text-sm font-semibold rounded border border-green-600 text-green-600 bg-green-100 hover:bg-green-50 transition disabled:opacity-50"
                      (click)="setStatus(row, 'Qualify'); $event.stopPropagation()"
                    >
                      <i class="pi pi-check-circle mr-2"></i>Shortlist
                    </button>
            
                    <button
                      [disabled]="!stepDetails.can_edit"
                      class="px-3 py-1 text-sm font-semibold rounded border border-red-600 bg-red-100 text-red-600 hover:bg-red-50 transition disabled:opacity-50"
                      (click)="setStatus(row, 'Disqualify'); $event.stopPropagation()"
                    >
                      <i class="pi pi-times-circle mr-2"></i> Not Shortlist
                    </button>
                  </div>
            
                  <i
                    class="pi transition-transform duration-200"
                    [ngClass]="row.isSectionOpen ? 'pi-chevron-down' : 'pi-chevron-right'"
                  ></i>
                </div>
            
                <!-- Details section -->
                <div
                  *ngIf="row.isSectionOpen"
                  class="p-1 space-y-4 border-t border-slate-100 animate-fade-in"
                >
                  <div class="bg-white rounded-lg shadow-sm p-2 border border-gray-200 mx-auto max-w-7xl">
                    <app-vender-specfic-document
                      [proposalStep]="stepDetails"
                      [vendorId]="row?.vendor?.id || row?.id" 
                      [isEdit]="stepDetails?.can_edit"
                      [url]="urls.vUrl"
                    >
                    </app-vender-specfic-document>
                  </div>
                </div>
              </div>
            </ng-container>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>